import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "col container" }
const _hoisted_2 = {
  class: "row data-row old-data-row",
  ref: "oldDataRow"
}
const _hoisted_3 = { class: "col-1 data-col" }
const _hoisted_4 = { class: "wrap-text" }
const _hoisted_5 = { class: "col-1 data-col" }
const _hoisted_6 = { class: "wrap-text" }
const _hoisted_7 = { class: "col-3 data-col" }
const _hoisted_8 = { class: "wrap-text" }
const _hoisted_9 = { class: "col-1 data-col" }
const _hoisted_10 = { class: "wrap-text" }
const _hoisted_11 = { class: "col-2 data-col" }
const _hoisted_12 = { class: "wrap-text" }
const _hoisted_13 = { class: "col-1 data-col" }
const _hoisted_14 = { class: "wrap-text" }
const _hoisted_15 = { class: "col-1 data-col" }
const _hoisted_16 = { class: "wrap-text" }
const _hoisted_17 = { class: "col-1 data-col" }
const _hoisted_18 = { class: "wrap-text" }
const _hoisted_19 = {
  class: "row data-row",
  ref: "dataRow"
}
const _hoisted_20 = { class: "col-1 data-col" }
const _hoisted_21 = { class: "wrap-text" }
const _hoisted_22 = { class: "col-1 data-col" }
const _hoisted_23 = { class: "wrap-text" }
const _hoisted_24 = { class: "col-3 data-col" }
const _hoisted_25 = { class: "wrap-text" }
const _hoisted_26 = { class: "col-1 data-col" }
const _hoisted_27 = { class: "wrap-text" }
const _hoisted_28 = { class: "col-2 data-col" }
const _hoisted_29 = { class: "wrap-text" }
const _hoisted_30 = { class: "col-1 data-col" }
const _hoisted_31 = { class: "wrap-text" }
const _hoisted_32 = { class: "col-1 data-col" }
const _hoisted_33 = { class: "wrap-text" }
const _hoisted_34 = { class: "col-1 data-col" }
const _hoisted_35 = { class: "wrap-text" }
const _hoisted_36 = { class: "col-1 data-col" }
const _hoisted_37 = { class: "wrap-text state-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["row row-frame", 'row-frame-' + _ctx.recordDiff.diffState])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.recordDiff.diffState === 'changed')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.recordDiff.oldData.dateString), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.recordDiff.oldData.productId), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.recordDiff.oldData.productName), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.recordDiff.oldData.areaAddress), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.recordDiff.oldData.place), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.recordDiff.oldData.resultCount), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.fixedStr(_ctx.recordDiff.oldData.sPrice)), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.fixedStr(_ctx.recordDiff.oldData.amount)), 1)
              ]),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-1 data-col" }, [
                _createElementVNode("span", { class: "wrap-text state-text" }, "変更前")
              ], -1))
            ], 512),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row arrow-row" }, [
              _createElementVNode("div", { class: "arrow" })
            ], -1))
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.recordDiff.dateString), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.recordDiff.productId), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.recordDiff.productName), 1)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.recordDiff.areaAddress), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.recordDiff.place), 1)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.recordDiff.resultCount), 1)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.fixedStr(_ctx.recordDiff.sPrice)), 1)
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.fixedStr(_ctx.recordDiff.amount)), 1)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.recordDiff.diffStateText), 1)
        ])
      ], 512)
    ])
  ], 2))
}